import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, Injector } from "@angular/core";
import { AgGridModule } from "ag-grid-angular";
import { GridOptions, GridApi, ColumnApi, ColDef } from "ag-grid";
import { AgGridNg2 } from "ag-grid-angular";

import { DataService } from "../../../../services/data/data.service";
import { TradeLines, IOrdersHistoryData, PrevChallengeTradeHistoryRs, MoneyLine } from '../../../../interfaces/service.response';
import { OrderPipsCellRenderer } from "../orderPipsCellRenderer.component";
import { OrderPnlCellRenderer } from "../orderPnlCellRenderer.component";
import { AppComponentBase } from '../../../../services/AppComponentBase';
import * as moment from "moment";
import {  NgbDateStruct, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { orderQtyCellRenderer } from "../orderQtyCellRenderer.component";
//import { dateFilterTypes } from "../../../date-selector/date-selector.component";

@Component({
    selector: "challengesHistoryList",
    template: require('./challengesHistoryList.component.html'),
    styles: [require('./challengesHistoryList.component.css')]
})
export class challengesHistoryListComponent extends AppComponentBase implements  AfterViewInit {
    @ViewChild("historyGrid") ordersGrid: any;
    @ViewChild("historyGridContainer") ordersGridContainer!: ElementRef;
    private _lockColumns = false;
    @Input("lockColumns")
    public set lockColumns(value: boolean) {
        this._lockColumns = value;
        // this.gridOptions.enableColResize = !this.lockColumns;

        if (this.gridColumnApi) {
            let defs: ColDef[] = [];
            this.gridColumnApi.getAllColumns().forEach(col => {
           //     console.log(col);
                let def = col.getColDef();
          //      console.log(def);
                def.suppressResize = value;
                def.suppressMovable = value;
                defs.push(def);
            });
            if (this.gridApi) {
                this.gridApi.setColumnDefs(defs, "gridOptionsChanged");
            }

            // if(this.gridColumnApi&&this.historyGridColumnsState!="null"&&this.historyGridColumnsState!="noSave"&&this.historyGridColumnsState!=null&&this.historyGridColumnsState!==undefined)
            // {
            //     let state = JSON.parse(this.historyGridColumnsState);    
            //     this.gridColumnApi.setColumnState(state)
            // }
            

        }
    }
    public rowSelection: any;
    public onColumnChange(e:any)
    {
         // (columnResized) = "onColumnChange($event)"
         // (columnMoved) = "onColumnChange($event)"

        if (this.gridColumnApi)
        {
        //  this.historyGridColumnsState = JSON.stringify(this.gridColumnApi.getColumnState());
        }
    }

    // public get historyGridColumnsState() {
        
    //   //  return this.workspace.historyGridColumnsState;

    // }

    // public set historyGridColumnsState(value: any) {
    //   //  this.workspace.historyGridColumnsState = value;
    // }


    public get lockColumns() {
        return this._lockColumns;
    }

    columnDefs: ColDef[] = [
        //  {headerName: 'Id', field: 'id', filter: "agNumberColumnFilter"},
        {
            headerName: "Entry Time",
            field: "EntryTime",
            filter: "agDateColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 140,
         //   minWidth: 140,
            maxWidth: 280
        },
        {
            headerName: "Close Time",
            field: "CloseTime",
            filter: "agDateColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 140,
       //     minWidth: 140,
            maxWidth: 280
        },
        {
            headerName: "Ticket",
            field: "Ticket",
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 80,
       //     minWidth: 80,
            maxWidth: 160,
            comparator: this.valComparator
        },
        {
            headerName: "Type",
            field: "Type",
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 110,
       //     minWidth: 110,
            maxWidth: 220
        },
        {
            headerName: "Qty",
            field: "Qty",
            cellRendererFramework: orderQtyCellRenderer,
            filter: "agNumberColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 90,
        //    minWidth: 90,
            maxWidth: 180,
            comparator: this.valComparator
        },
        {
            headerName: "Symbol",
            field: "Symbol",
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 110,
       //     minWidth: 110,
            maxWidth: 220
        },
        {
            headerName: "Entry Price",
            field: "EntryPrice",
            filter: "agNumberColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 100,
       //     minWidth: 100,
            maxWidth: 200,
            comparator: this.valComparator
        },
        {
            headerName: "Stop",
            field: "Stop",
            filter: "agNumberColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 90,
        //    minWidth: 90,
            maxWidth: 180,
            comparator: this.valComparator
        },
        {
            headerName: "Limit",
            field: "Limit",
            filter: "agNumberColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 90,
       //     minWidth: 90,
            maxWidth: 180,
            comparator: this.valComparator
        },
        {
            headerName: "Close Price",
            field: "ClosePrice",
            filter: "agNumberColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 90,
        //    minWidth: 90,
            maxWidth: 180,
            comparator: this.valComparator
        },
        {
            headerName: "Pips",
            cellRendererFramework: OrderPipsCellRenderer,
            field: "Pips",
            filter: "agNumberColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 90,
       //     minWidth: 90,
            maxWidth: 180,
            comparator: this.valComparator
        },
        {
            headerName: "Profit/Loss",
            cellRendererFramework: OrderPnlCellRenderer,
            field: "PnLUSD",
            filter: "agNumberColumnFilter",
            cellStyle: { "text-align": "right" },
            width: 110,
      //      minWidth: 110,
            maxWidth: 220,
            comparator: this.valUPLComparator
        }
    ];

    public gridOptions: GridOptions;
    private gridApi: GridApi | undefined;
    private gridColumnApi: ColumnApi | undefined;

    public onGridReady(params: GridOptions) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

        this.gridApi!.showLoadingOverlay();
        
    }

    //private gridAPI:GridApi;
    constructor(injector: Injector, protected elRef: ElementRef, public dataService: DataService, public parserFormatter: NgbDateParserFormatter) {

        super(injector);;
        this.workspace.dateFilterTypeChallenge = "all";


        this.gridOptions = <GridOptions>{};
        //   this.gridAPI = this.gridOptions.api;

        this.gridOptions.defaultColDef = {
            // set every column width
            cellClass: "orders-cell",
            width: 150
        };

        
        this.gridOptions.enableFilter = true;
        this.gridOptions.sortingOrder = ['desc','asc','null'];
        this.gridOptions.enableSorting = true;
        /*
            for(var l=0;l<100;l++)
              {
                var t:IOrdersHistoryData ={
                                    id:l++,
                                    symbol:"EUR/USD",
                                    direction:"buy",
                                    stime:" ",
                                    type:"Market",
                                    submittedprice:4.00,
                                    entryprice:4.00,
                                    fillpx:2
                                  };
                this.addRow(t);
              }
              */

        let today = moment();

        dataService.dataSubscriber.subscribe(response => {
            if (response) {
                switch (response.Type) {
                    case "PrevChallengeTradeHistoryRs":
                      this.trendLines = <PrevChallengeTradeHistoryRs>response;     
                        

                    

                      let historyLines = this.filterResponse( this.trendLines);
                        
                            //   if (this.gridApi) this.gridApi.setRowData([]);
                            //  this.addItems(trendLines.HistoryLines);
                            this.updateItems( historyLines);
                            this.workspace.historyChallengeAccountMoneyLine =  this.trendLines.MoneyLine;
                     
                }
            }

        });


        this.workspace.globaGridMode.dateFilterChallenge.subscribe(v=>{
            let historyLines = this.filterResponse( this.trendLines);
            this.updateItems( historyLines);
        
        })







        // this.globaGridMode.sendHistoryOrderGridChange.subscribe((v)=>{

           
        //     if (this.gridColumnApi&&this.historyGridColumnsState!="null"&&this.historyGridColumnsState!="noSave"&&this.historyGridColumnsState!=null&&this.historyGridColumnsState!==undefined)
        //     {
              
        //         let state = JSON.parse(this.historyGridColumnsState);
                
        //          this.gridColumnApi.setColumnState(state)
        //     }


        // })


        this.getRowNodeId = function(data: IOrdersHistoryData) {
            return data.CloseTime + data.Symbol + data.Type + data.Ticket;
        };

        this.rowSelection = "single";



    }

    public trendLines: any;

    public dateStructToString(date: NgbDateStruct):string
    {
        return String(date.year) + "-" + String(date.month) + "-" + String(date.day)
    }


    public   filterResponse (responseData:TradeLines)
    {
        
        let filtered = responseData.HistoryLines.filter(v=>{

           
            let filterType =  this.currentFilterType;

            let toCompare = moment(v.CloseTime, 'YYYY-MM-DD');
            //toCompare = moment(v.CloseTime, 'YYYY-MM-DD');

            // if(filterType!="custom")
            // {
            //      toCompare = moment(v.EntryTime, 'YYYY-MM-DD');
            // }
            // else
            // {
            //     toCompare = moment(v.CloseTime, 'YYYY-MM-DD');
            // }

            this.workspace.pdfReportHistoryDateStrChallenge = "All";


            switch (filterType)
            {
                case "today": {  

                    this.workspace.pdfReportHistoryDateStrChallenge = "Today " + moment(new Date()).format('YYYY-MM-DD');
                    this.workspace.pdfReportHistoryDateRange = {from:moment( new Date() ), to: moment( new Date() )}
                    return toCompare.isSame(new Date(), "day")
                };

                case "lastweek": { 

                    this.workspace.pdfReportHistoryDateStrChallenge = "LastWeek " +  moment().subtract(7,'days').format('YYYY-MM-DD') + " - " + moment(new Date()).format('YYYY-MM-DD');
                  //  return toCompare.isSame(new Date(), "week")
                   let dateTo = moment().format('YYYY-MM-DD');
                    let dateFrom = moment().subtract(7,'days').format('YYYY-MM-DD');
                    this.workspace.pdfReportHistoryDateRange = {from:moment(), to: moment().subtract( 7, 'days' )}
                //    return toCompare.isSame(new Date(), "week")
                    return toCompare.isBetween(dateFrom, dateTo) || toCompare.isSame(new Date(), "day");
                };

                case "3d": {  
                    let dateTo = moment().format('YYYY-MM-DD');
                    let dateFrom = moment().subtract(3,'days').format('YYYY-MM-DD');

                    this.workspace.pdfReportHistoryDateStrChallenge = "3 days " + dateFrom + " - " + dateTo;
                    this.workspace.pdfReportHistoryDateRange = {from:moment(), to: moment().subtract( 3, 'days' )}
                     return toCompare.isBetween(dateFrom, dateTo) || toCompare.isSame(new Date(), "day");
                    };

                case "custom": {

                    if(this.workspace.fromDateFilterChallenge!=undefined &&this.workspace.toDateFilterChallenge !=undefined)
                    {

                        console.log('this.workspace.globaGridMode.dateFilter');
                        console.log(this.trendLines);
                        console.log([ this.parserFormatter.format(this.workspace.fromDateFilterChallenge), this.parserFormatter.format(this.workspace.toDateFilterChallenge)]);

                        let fromDate = moment(this.parserFormatter.format(this.workspace.fromDateFilterChallenge), 'YYYY-MM-DD');
                        let toDate = moment(this.parserFormatter.format(this.workspace.toDateFilterChallenge), 'YYYY-MM-DD');

                        this.workspace.pdfReportHistoryDateStrChallenge = "Custom " + fromDate.format('YYYY-MM-DD') + " - " + toDate.format('YYYY-MM-DD');
                        this.workspace.pdfReportHistoryDateRange = {from:moment( this.parserFormatter.format( this.workspace.fromDateFilterChallenge )), to: moment( this.parserFormatter.format( this.workspace.toDateFilterChallenge ))}
                        if(toDate.isBefore(fromDate))
                        {
                            return false;
                        }

                        return toCompare.isBetween(fromDate, toDate) || toCompare.isSame(toDate, "day") || toCompare.isSame(fromDate, "day");
                    }

                //    this.dateStructToString(this.workspace.fromDateFilter), this.dateStructToString(this.workspace.toDateFilter)

                        
                    };
            }

            //  console.log([v.EntryTime, toCompare, today, toCompare.isSame(new Date(), "day")] );
            return true;
        })
        return filtered;
    }










    public get currentFilterType():string
    {
        return this.workspace.dateFilterTypeChallenge;
    }


    private orderDataId: string[] = [];

    updateItems(v: IOrdersHistoryData[]) {
        if (v) {
            v.forEach(element => {
                if (this.gridApi) {
                    let id = element.CloseTime + element.Symbol + element.Type + element.Ticket;
                    let rowNode = this.gridApi.getRowNode(id);

                 
                    if (rowNode) {
                    //     element.MarketPrice=100*Math.random();
                    //     element.Pips=100*Math.random();
                    //     element.PnLUSD=100*Math.random();
                    //  console.log("element");
                    //  console.log(element);

                        rowNode.setData(element);
                        this.gridApi.refreshCells({force: true});
                    } else {
                        this.gridApi.updateRowData({ addIndex: 0, add: [element] });
                        this.orderDataId.push(id);
                    }

                  
                   

                }
            });
            let forRemove: string[] = [];
            this.orderDataId.forEach(id => {
                if (v.filter(element => element.CloseTime + element.Symbol + element.Type +element.Ticket == id).length == 0) {
                    if (this.gridApi) {
                        let rowNode = this.gridApi.getRowNode(id);
                        if(rowNode!==undefined)
                        {
                           
                           
                             this.gridApi.updateRowData({ remove: [rowNode.data] });
                        }
                    }
                    forRemove.push(id);
                }
            });
            this.orderDataId = this.orderDataId.filter(x => forRemove.indexOf(x) < 0);





        this.workspace.visibleHistoryChallengeData = v;

        }

        
    }

    public getRowNodeId: any;


    ngAfterViewInit() {

    }

    public ordersData: IOrdersHistoryData[] = [];

    public addRow(data: IOrdersHistoryData) {
        this.ordersData.push(data);
    }

    onAddRow() {
    if (this.gridApi){
         var res = this.gridApi.updateRowData({ add: [{
            EntryTime: '20018-01-1',
            Ticket: '1',
            Type: 'Buy',
            Qty: '1',
            Symbol: 'AUD/CAD',
            EntryPrice: '0.9999',
            Stop: '0.9999',
            Limit: '0.99999',
            ClosePrice: '0.99999',
            Pips: '-1',
            PnLUSD: '($)-0.16'
        }] });
     }
    }

    addItems(v: IOrdersHistoryData[]) {
        var newItems: any[] = [];

        v.forEach((element: any) => {
            var t: IOrdersHistoryData = {
                EntryTime: element.EntryTime,
                CloseTime: element.CloseTime,
                Ticket: element.Ticket,
                Type: element.Type,
                Qty: element.Qty,
                Symbol: element.Symbol,
                EntryPrice: element.EntryPrice,
                Stop: element.Stop,
                Limit: element.Limit,
                ClosePrice: element.ClosePrice,
                Pips: element.Pips,
                PnLUSD: element.PnLUSD
            };
            newItems.push(t);
        });
        //console.log(newItems);

        if (this.gridApi) {
            var res = this.gridApi.updateRowData({ add: newItems });
        }
    }



    public valComparator(val1:any, val2:any) {
        let v1 = Number(val1);
        let v2 = Number(val2);

       
        if (v1 === null && v2 === null) {
            return 0;
          }
          
          return v1 - v2;
    }

    public valUPLComparator(val1:any, val2:any) {



        let v1 = Number(val1.replace("($)", "").replace("$", ""));
        let v2 = Number(val2.replace("($)", "").replace("$", ""));

        
        if (v1 === null && v2 === null) {
            return 0;
          }
          
          return v1 - v2;
    }
}

/*
{
  Cmd:"History",
  History:
  [
  {
  EntryTime:"..."
  Ticket
  Type
  Qty
  Symbol
  EntryPrice
  Stop
  Limit
  ClosePrice
  Pips
  PnLUSD
  }
  ]
  }
*/

//.ag-body-viewport
